module.exports = __webpack_public_path__ + "static/media/turntable-wrapper.9789ac67.png";